const getTransitionEvent = () => {
  const el = document.createElement('element');
  const transitions = {
    transition: 'transitionend',
    OTransition: 'oTransitionEnd',
    MozTransition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
  };
  let t;
  for(t in transitions) {
    if(el.style[t] !== undefined) {
      return transitions[t];
    }
  }
  return false;
};

export const isSupported = !!getTransitionEvent();
export const event = getTransitionEvent();

export default {
  isSupported,
  event,
};



/** WEBPACK FOOTER **
 ** ./modules/css-transition/index.js
 **/